import { IconMathFunction } from '@rossum/ui/icons/tabler';
import { SvgIcon, SvgIconProps } from '@rossum/ui/material';

export const Formula = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <IconMathFunction />
  </SvgIcon>
);
